/**
 * Standard strong password policy.
 *
 * Rules:
 * - Minimum 8 characters
 * - At least one uppercase letter
 * - At least one lowercase letter
 * - At least one digit
 * - At least one special character
 */

const MIN_LENGTH = 8;
const UPPERCASE_REGEX = /[A-Z]/;
const LOWERCASE_REGEX = /[a-z]/;
const DIGIT_REGEX = /[0-9]/;
// eslint-disable-next-line no-useless-escape
const SPECIAL_REGEX = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>/?]/;

const SPECIAL_CHARS = '!@#$%^&*()_+-=[]{};\':"|,.<>/?';
const UPPERCASE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const LOWERCASE_CHARS = 'abcdefghijklmnopqrstuvwxyz';
const DIGIT_CHARS = '0123456789';
const ALL_CHARS = UPPERCASE_CHARS + LOWERCASE_CHARS + DIGIT_CHARS + SPECIAL_CHARS;

function shuffle(array) {
  const result = [...array];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

export function validatePassword(password) {
  const errors = [];

  if (!password || password.length < MIN_LENGTH) {
    errors.push(`Password must be at least ${MIN_LENGTH} characters long.`);
  }

  if (!UPPERCASE_REGEX.test(password)) {
    errors.push('Password must contain at least one uppercase letter.');
  }

  if (!LOWERCASE_REGEX.test(password)) {
    errors.push('Password must contain at least one lowercase letter.');
  }

  if (!DIGIT_REGEX.test(password)) {
    errors.push('Password must contain at least one number.');
  }

  if (!SPECIAL_REGEX.test(password)) {
    errors.push('Password must contain at least one special character.');
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}

export function generateCompliantPassword(length = 12) {
  const targetLength = Math.max(length, MIN_LENGTH);

  const chars = [
    UPPERCASE_CHARS[Math.floor(Math.random() * UPPERCASE_CHARS.length)],
    LOWERCASE_CHARS[Math.floor(Math.random() * LOWERCASE_CHARS.length)],
    DIGIT_CHARS[Math.floor(Math.random() * DIGIT_CHARS.length)],
    SPECIAL_CHARS[Math.floor(Math.random() * SPECIAL_CHARS.length)],
  ];

  for (let i = chars.length; i < targetLength; i++) {
    chars.push(ALL_CHARS[Math.floor(Math.random() * ALL_CHARS.length)]);
  }

  return shuffle(chars).join('');
}
